import React from 'react';
import styled from 'styled-components/macro';
import {
  COLORS,
  Flex,
  Icon,
  Image,
  Spacer,
  Text,
} from '@podiumhq/design-system';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';

const Card = ({ showArrow, onCardClick, icon, header, content }) => {
  return (
    <Wrapper onClick={onCardClick}>
      <Flex align="center">
        <Flex direction="column" justify="center">
          <Image width="48px" height="48px" src={icon} />
        </Flex>
        <Flex
          paddingRight="16px"
          marginLeft="16px"
          direction="column"
          justify="center"
        >
          <Text
            color={COLORS.black.base}
            marginBottom="4px"
            fontSize="lg"
            fontWeight="medium"
          >
            {header}
          </Text>
          <Text color={COLORS.black.base} fontSize="sm">
            {content}
          </Text>
        </Flex>
        <Spacer />
        {showArrow && <Icon boxSize={4} color="grey.base" type="AngleRight" />}
      </Flex>
    </Wrapper>
  );
};

export default Card;

const Wrapper = styled.div`
  border: 1px solid ${COLORS.silver.base};
  border-radius: 8px;
  padding: 16px;
  margin-top: 24px;
  height: 100%;
  &:hover {
    cursor: pointer;
    background-color: ${COLORS.silver.light};
  }

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    :first-child {
      margin-top: 0px;
    }
  }
`;
